import { PublicationTheme, PublicationTemplateId } from './types'

export const publicationThemes: Record<
  PublicationTheme,
  {
    card: string
    surface: string
    textPrimary: string
    textSecondary: string
    accent: string
    badge: string
    background: string
  }
> = {
  'minimal-clean': {
    card: 'bg-[#F8F5EF]',
    surface: 'bg-white/70',
    textPrimary: 'text-[#23201B]',
    textSecondary: 'text-[#5C554B]',
    accent: 'text-[#B88352]',
    badge: 'bg-white/80 text-[#4A4339]',
    background: 'bg-gradient-to-br from-[#F8F5EF] to-[#EFE8DD]',
  },
  'soft-botanical': {
    card: 'bg-[#EFF1E8]',
    surface: 'bg-white/65',
    textPrimary: 'text-[#263025]',
    textSecondary: 'text-[#5B6957]',
    accent: 'text-[#7C8B5A]',
    badge: 'bg-white/75 text-[#4E5B49]',
    background: 'bg-gradient-to-br from-[#F2F4EC] to-[#DDE5D3]',
  },
  'warm-natural': {
    card: 'bg-[#F6EEE4]',
    surface: 'bg-white/65',
    textPrimary: 'text-[#33261D]',
    textSecondary: 'text-[#6A5545]',
    accent: 'text-[#B77B48]',
    badge: 'bg-white/75 text-[#5E4B3D]',
    background: 'bg-gradient-to-br from-[#FAF4EC] to-[#EBDAC5]',
  },
  'luxury-glow': {
    card: 'bg-[#F4E8D7]',
    surface: 'bg-white/60',
    textPrimary: 'text-[#2B2218]',
    textSecondary: 'text-[#6A5848]',
    accent: 'text-[#B68A43]',
    badge: 'bg-white/75 text-[#5A4939]',
    background: 'bg-gradient-to-br from-[#F6EAD8] to-[#E7D0A9]',
  },
}

export const publicationTemplates: Record<
  PublicationTemplateId,
  {
    id: PublicationTemplateId
    name: string
    format: 'image' | 'carousel'
  }
> = {
  'single-hero-split': {
    id: 'single-hero-split',
    name: 'Single Hero Split',
    format: 'image',
  },
  'single-product-focus': {
    id: 'single-product-focus',
    name: 'Single Product Focus',
    format: 'image',
  },
  'carousel-premium-framework': {
    id: 'carousel-premium-framework',
    name: 'Carousel Premium Framework',
    format: 'carousel',
  },
}